import { render, staticRenderFns } from "./QuestionnaireDetail.vue?vue&type=template&id=0d99a721&scoped=true"
import script from "./QuestionnaireDetail.vue?vue&type=script&lang=js"
export * from "./QuestionnaireDetail.vue?vue&type=script&lang=js"
import style0 from "./QuestionnaireDetail.vue?vue&type=style&index=0&id=0d99a721&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d99a721",
  null
  
)

export default component.exports